<template>
   <div class="login-talk">
       <van-dialog v-model="unlockingShow" 
              title="提示" message="您还未绑定手机号，是否点击确定去绑定手机号？" 
              confirm-button-color="#0075fd"
              cancel-button-color="#8d8d8d"
              @confirm="confirmLock"
              @cancel="cancel"
              show-cancel-button>
       </van-dialog> 
   </div>
</template>

<script>
// headers
export default {
    name:"MobileTalk",
    mounted(){
    },
    data () {
        return {
            unlockingShow:false
        }
    },
    methods: {
        control(){
           this.unlockingShow=!this.unlockingShow
        },
        confirmLock() {
           this.$router.push({name: 'mobile'})
        },
        cancel(){
           this.$emit("cancelEvent");
        }
    }
}
</script>
<style  lang='scss' scoped>
.login-talk{
    .van-dialog{
      width: 540px;
      border-radius: 20px;
      ::v-deep.van-dialog__content{
        border-bottom: 1px solid #8d8d8d;
      }
      ::v-deep.van-dialog__cancel{
       border-right: 1px solid #8d8d8d;
      }
    }
}
</style>